<template>
  <div class="builder__text-option">
    <div class="builder__text-option-name">
      <label :for="domId">{{ option.display_title ? option.display_title : option.title }}:</label>
    </div>
    <div class="builder__text-option-choice">
      <textarea
       class="builder__text-option-choice-input"
       :id="domId"
       :maxlength="(option.character_limit ? option.character_limit : '')"
       v-model="text"
      ></textarea>
    </div>

    <div v-if="option.help_text" class="builder__step-note">
      {{ option.help_text }}
    </div>

  </div>
</template>

<script>
  export default {
    name: 'builder-option-textarea',
    props: ['option'],
    data() {
      return {
        domId: 'product-step-option-' + this.option.id,
      }
    },

    computed: {
      text: {
        get() { return this.option.selected_value },
        set(newValue) { this.$emit('input', newValue.trim()) },
      },
    },
  }
</script>



// WEBPACK FOOTER //
// Textarea.vue?475f03dc